import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { featuredProducts } from '@/mocks/products';
import ProductCard from './ProductCard';
import useCarousel from '@/hooks/useCarousel';

const FeaturedProductsSection = () => {
  const { t } = useTranslation();
  const { currentIndex, containerRef, trackStyle, itemStyle, prev, next, goTo, canPrev, canNext, dotsCount, pauseAutoplay, resumeAutoplay } = useCarousel({
    total: featuredProducts.length,
    visibleCards: 3,
    gap: 24,
    autoplay: true,
    autoplayInterval: 4000,
  });

  return (
    <section className="bg-[#0a0a0a] py-20 px-6 md:px-10 xl:px-16" data-product-shop>
      <div className="max-w-[1400px] mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-4">
          <div>
            <p className="text-[#c9a84c] text-xs tracking-[0.3em] uppercase mb-3 font-medium">{t('featured_label')}</p>
            <h2
              className="text-4xl md:text-5xl font-light text-white"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              {t('featured_title')}
            </h2>
          </div>
          <div className="flex items-center gap-6">
            <div className="flex items-center gap-3">
              <button
                onClick={prev}
                disabled={!canPrev}
                className="w-10 h-10 flex items-center justify-center border border-white/20 rounded-full text-white/60 hover:border-[#c9a84c] hover:text-[#c9a84c] transition-all duration-300 disabled:opacity-25 disabled:cursor-not-allowed cursor-pointer"
                aria-label="Previous"
              >
                <i className="ri-arrow-left-line text-sm"></i>
              </button>
              <button
                onClick={next}
                disabled={!canNext}
                className="w-10 h-10 flex items-center justify-center border border-white/20 rounded-full text-white/60 hover:border-[#c9a84c] hover:text-[#c9a84c] transition-all duration-300 disabled:opacity-25 disabled:cursor-not-allowed cursor-pointer"
                aria-label="Next"
              >
                <i className="ri-arrow-right-line text-sm"></i>
              </button>
            </div>
            <Link
              to="/loja"
              className="flex items-center gap-2 text-[#c9a84c] text-xs tracking-widest uppercase font-medium hover:gap-3 transition-all whitespace-nowrap"
            >
              {t('featured_see_all')}
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>

        <div
          onMouseEnter={pauseAutoplay}
          onMouseLeave={resumeAutoplay}
        >
          <div ref={containerRef} className="overflow-hidden">
            <div className="flex" style={trackStyle}>
              {featuredProducts.map(product => (
                <div key={product.id} style={itemStyle}>
                  <ProductCard product={product} />
                </div>
              ))}
            </div>
          </div>

          <div className="flex items-center justify-center gap-2 mt-10">
            {Array.from({ length: dotsCount }).map((_, i) => (
              <button
                key={i}
                onClick={() => goTo(i)}
                className={`transition-all duration-300 rounded-full cursor-pointer ${
                  i === currentIndex ? 'w-8 h-1.5 bg-[#c9a84c]' : 'w-1.5 h-1.5 bg-white/20 hover:bg-white/40'
                }`}
                aria-label={`Go to slide ${i + 1}`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturedProductsSection;
